<template>
  <v-card class="mx-auto">
    <v-img
      class="align-end text-white"
      height="140"
      src="/time-of-the-day.webp"
      contain
    />

    <v-card-text>
      <HelpFormInput
        textarea
        v-model="name"
        label="Campaign Name"
        placeholder="Campaign Name"
        help-text="Give recognizable name to your new Campaign."
        :rules="rules.name"
        @update:model-value="(v) => onUpdate({ ...modelValue, name: v })"
      />
      <HelpDateInput
        v-model="startDate"
        label="Start Date"
        placeholder="Start Date"
        :rules="rules.startDate"
        help-text="The start date of the campaign."
        :min="new Date().toISOString().substr(0, 10)"
        :max="endDate ? endDate.toISOString().substr(0, 10) : null"
        @update:model-value="
          (v) =>
            onUpdate({
              ...modelValue,
              settings: {
                ...(modelValue.settings || {}),
                startDate: v,
              },
            })
        "
      />
      <HelpDateInput
        v-model="endDate"
        label="End Date"
        placeholder="End Date"
        :help-text="'The end date of the campaign.'"
        :rules="rules.endDate"
        :min="startDate ? startDate.toISOString().substr(0, 10) : null"
        :max="null"
        @update:model-value="
          (v) =>
            onUpdate({
              ...modelValue,
              settings: {
                ...(modelValue.settings || {}),
                endDate: v,
              },
            })
        "
      />
    </v-card-text>
  </v-card>
</template>
      
      
      <script>
import HelpDateInput from "@/components/atoms/common/inputs/HelpDateInput.vue";
import HelpFormInput from "../../atoms/common/inputs/HelpFormInput.vue";

export default {
  components: {
    HelpFormInput,
    HelpDateInput,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["next", "update:modelValue"],
  data() {
    return {
      name: null,
      startDate: null,
      endDate: null,

      rules: {
        name: [
          (v) => !!v || "Name is required",
          (v) =>
            (v && v.length <= 250) || "Name must be less than 250 characters",
        ],
        startDate: [(v) => !!v || "Start Date is required"],
        endDate: [
          (v) => !!v || "End Date is required",
          (v) =>
            (this.startDate && new Date(v) >= this.startDate) ||
            "End Date must be greater than Start Date",
        ],
      },
    };
  },
  computed: {},

  created() {},
  methods: {
    onUpdate(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>